import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

declare global {
  interface Window {
    DYO: any;
    DY: any;
    dyid: any
  }
}
@Injectable({
  providedIn: 'root'
})

export class DYService {
  public isBrowser: boolean;
  public cityName: string;
  public cityDefault: string = 'Bogota';
  public cookieDyServerName:string = '_dyid_server'
  public cookieDyName:string = '_dyid'

  constructor(@Inject(PLATFORM_ID) platformId) {
    this.isBrowser = isPlatformBrowser(platformId) && !(navigator.userAgent.indexOf('Chrome-Lighthouse') > -1);
  }

  setCityContext(city: string): void {
    this.cityName = city || this.cityDefault;
    if (this.isBrowser && window.DY?.recommendationContext) {
      this.initializeWindowDY()
      window.DY.recommendationContext.lng = this.cityName;
    };
  }

  setContext<T>(type?: string, data?: Array<T> | string): void {
    if (!this.isBrowser) {
      return;
    }

    this.initializeWindowDY()
    let context: { type: string; lng: string; data?: any } = {
      type,
      lng: this.cityName || this.cityDefault,
    };

    if (data !== undefined) {
      context.data = data;
    }

    window.DY.recommendationContext = context;

    setTimeout(() => {
      this.setScriptApi('api_dynamic');
      this.setScriptApi('api_static');
    }, 2000);
  }

  setCookieDY(): void {
    if (!this.isBrowser) {
      return;
    }
    const expire = 30240000;
    const regexDyidserver = /_dyid_server=([a-zA-Z0-9_-]+)/;
    const regexDyid = /_dyid=([a-zA-Z0-9_-]+)/;
    const [, valueDyidserver] = regexDyidserver.exec(document.cookie) || [];
    const [, valueDyid] = regexDyid.exec(document.cookie) || [];

    if (valueDyidserver) {
      this.setCookieValues(valueDyidserver, expire, this.cookieDyServerName);
    } 
    else if (window.dyid && !valueDyid) {
      this.setCookieValues(window.dyid, expire, this.cookieDyName);
      setTimeout(() => {
        this.setCookieValues(window.dyid, expire, this.cookieDyServerName);
      }, 1000)
    }
    else if (window.dyid && valueDyid) {
      this.setCookieValues(window.dyid, expire, this.cookieDyServerName);
    }
  }

  setCookieValues(value: string, expire: number, name?: string): void {
    document.cookie = `${name}=${value}; path=/; max-age=${expire}; secure;`;
  }

  setScriptApi(api): void {
    const script = document.createElement('script');
    script.src = `https://cdn.dynamicyield.com/api/8786412/${api}.js`;
    script.type = "text/javascript"
    const existingScript = document.querySelector(`script[src="${script.src}"]`);
    if (!existingScript) {
      document.head.appendChild(script);
    }
  }

  initializeWindowDY() {
    window.DY = window.DY || {};
  }
}

